import camelCase from "lodash/camelCase";
import { useTheme } from "styled-components";
import { useTranslation } from "react-i18next";
import { Box, Text, TooltipWrapper } from "dash-ui";
import { ProjectStatusesEnum } from "dash-common";

import { Property } from "gql/generated.graphql";

const ProjectStatusRow = ({
  property,
  smallScale,
  tooltip = true,
}: {
  property: Property;
  smallScale?: boolean;
  tooltip?: boolean;
}) => {
  const theme = useTheme();
  const { t } = useTranslation();

  const { projectStatus, yearBuilt } = property;

  const formattedYearBuilt = yearBuilt
    ? t(
        `pages:propertyPage.${
          projectStatus === ProjectStatusesEnum.NEW_CONSTRUCTION ||
          projectStatus === ProjectStatusesEnum.COMPLETED
            ? "completedIn"
            : "estCompletion"
        }`,
        {
          date: yearBuilt,
        }
      )
    : "";

  const projectStatusText =
    projectStatus &&
    projectStatus !== ProjectStatusesEnum.COMING_SOON &&
    projectStatus !== ProjectStatusesEnum.COMPLETED
      ? t(`forms:labels.projectStatuses.${camelCase(projectStatus || "")}`)
      : "";

  const rowText =
    projectStatus &&
    projectStatus !== ProjectStatusesEnum.COMING_SOON &&
    projectStatus !== ProjectStatusesEnum.COMPLETED &&
    yearBuilt
      ? [projectStatusText, formattedYearBuilt].join(", ")
      : formattedYearBuilt || projectStatusText;

  const content = (
    <Box maxWidth="100%">
      <Text ellipsis sm={smallScale} color={theme.colors.n80}>
        {rowText}
      </Text>
    </Box>
  );

  return (
    <Box mt={0.5} h={24} w="100%">
      {tooltip ? (
        <TooltipWrapper content={rowText} sm={smallScale}>
          {content}
        </TooltipWrapper>
      ) : (
        content
      )}
    </Box>
  );
};

export default ProjectStatusRow;
